// extracted by mini-css-extract-plugin
export default {"multipleSwitchOptions":"Switch_multipleSwitchOptions__RuDkh"};